import { EReportColumnHeader } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { TGlobalMetrics } from '../../../models'

export const genericMetricNames: Array<TGlobalMetrics> = [
  EReportColumnHeader.Impressions,
  EReportColumnHeader.Clicks,
  EReportColumnHeader.Ctr,
  EReportColumnHeader.Costs,
  EReportColumnHeader.ShareOfVoice,
  EReportColumnHeader.WinRate,
  // EReportColumnHeader.AvgRank, // not available yet
  EReportColumnHeader.Carts,
  EReportColumnHeader.Purchases,
  EReportColumnHeader.Revenue,
  EReportColumnHeader.Roas,
  EReportColumnHeader.NewToBrandPurchases,
  EReportColumnHeader.NewToBrandRevenue,
]
